const ROOT = 'TALENT_VIEW_SKILL_MODAL_';

const actions = {
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
  LOAD_VIEW_DATA_SUCCESS: `${ROOT}LOAD_VIEW_DATA_SUCCESS`,
  CLEAR_STATE: `${ROOT}CLEAR_STATE`,
} as const;

export default actions;
